import { FC } from 'react'

import { Card } from '@joor/design-system'

import { Order } from '../../types'
import { Contact } from 'features/Orders/components/Contacts/Contact'

export const NO_SALES_REP_TEXT = 'No Sales Representative'

const SalesRep: FC<{ order: Order }> = ({ order }) => (
  <Card title="Sales Rep">
    {order.salesRepresentative ? (
      <Contact
        key={order.salesRepresentative?.id}
        name={order.salesRepresentative?.name}
        email={order.salesRepresentative?.email}
      />
    ) : (
      <div>{NO_SALES_REP_TEXT}</div>
    )}
  </Card>
)
export default SalesRep
